import * as React from "react";
const SvgDash = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 4, viewBox: "0 0 12 4", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M12 2H0" }));
export default SvgDash;
